
























































































































import {Component, Prop, Vue, Watch} from 'vue-property-decorator';
import ZCLogo from '../assets/logo.svg';
import {BadgeStore, IBadge} from '@/store/modules/badge.store';
import {ITicket, TicketStore} from '@/store/modules/ticket.store';
import {find} from 'lodash';
import {CurrencyFilter} from '@/filters/currency';
import {WebService} from '@/services/web.service';
import { OverlayShowTime } from '@/constants';
import {MenuStore} from '@/store/modules/menu.store';
import {
	CartStore,
	ICartMergedItem,
	ICartMergedItemOption
} from '@/store/modules/cart.store';
import {LocationStore} from '@/store/modules/location.store';
import QRCodeOverlay from '@/components/QRCodeOverlay.vue';
import ItemMenu from '@/components/ItemMenu.vue';
// @ is an alias to /src

interface ILocalBadge {
	name: string;
	badgeId: string;
	ticketId: string;
	state: 'OPEN' | 'SENT' | 'VIEWED' | 'UNDERPAID' | 'PAID' | 'CANCELLED' | 'UNASSIGNED';
	ticket: ITicket | null;
}

@Component({
	components: {
		ZCLogo,
		'qr-code-overlay': QRCodeOverlay,
		'item-menu': ItemMenu
	}
})
export default class InnerBadge extends Vue {
	@Prop({default: null})
	badgeId!: string | null;

	@Prop({default: null})
	ticketId!: string | null;

	@Prop({default: false})
	reusable!: boolean;

	internalBadgeId: string | null = null;
	oldInternalBadgeId: string | null = null;
	readOnlyBadge = false;

	internalTicketId: string | null = null;

	billAmountInput = '';


	customerId: string | null = null;
	customerPhone = '';
	customerPhoneFocused = false;
	customerName = '';
	showMoreActions = false;

	showOverlay = false;
	overlayColor = 'green';
	overlayMessage = '';

	showQRCode = false;

	showLoading = false;

	dataLoaded = false;

	showItemMenu = false;

	showItemOptions = false;
	selectedItemId = '';
	selectedMenuId = '';
	selectedLineItemId = 0;

	get ticket() {
		if(this.internalTicketId !== null) {
			return TicketStore.byId(this.internalTicketId);
		}
		if(this.internalBadgeId !== null) {
			return TicketStore.ticketByBadgeId(this.internalBadgeId);
		}
		return null;
	}

	get location() {
		return LocationStore.location;
	}

	get billOnly() {
		if(this.location) {
			return !this.location.isOrderingAvailable;
		}
		return true;
	}

	get isOrderingAvailable() {
		if(!this.ticket) {
			return false;
		}
		return this.ticket.isOrderingAvailable;
	}

	get menuId() {
		return MenuStore.activeMenuId;
	}

	optionsText(item: any) {
		const optionText: string[] = [];
		item.options.forEach((selectedOption: ICartMergedItemOption) => {
			const selectedChoiceText: string[] = [];
			if(selectedOption.choices.length) {
				selectedOption.choices.forEach((selectedChoice) => {
					selectedChoiceText.push(selectedChoice.name);
				});
				optionText.push(selectedChoiceText.join(', '));
			}
		});
		return optionText.join(', ');
	}

	get lineItems() {
		if(!this.ticket || this.ticket.lineItems === null) {
			return [];
		}

		return CartStore.mergeItems(this.ticket.lineItems.map((item) => {
			return {
				lineItemId: item.lineItemId,
				ticketId: item.ticketId,
				courseId: item.courseId,
				menuId: item.menuId,
				itemId: item.itemId,
				quantity: 1,
				options: item.options,
				specialRequests: item.comments || '',
				total: item.total,
				status: item.status
			};
		}));
	}

	get totalPrice() {
		if(!this.ticket || this.ticket.lineItems === null) {
			return 0;
		}
		return this.ticket.lineItems.reduce((total, lineItem) => {
			return total + lineItem.total;
		}, 0);
	}

	get badge() {
		if(this.internalBadgeId !== null) {
			return BadgeStore.byId(this.internalBadgeId);
		}
		return null;
	}

	@Watch('badge')
	async onBadgeChange(currentBadge: IBadge | null, oldBadge: IBadge | null) {
		if(this.dataLoaded) {
			if(oldBadge !== null && currentBadge !== null && oldBadge.modId === currentBadge.modId) {
				// There was no change
				return;
			}
			console.log('Badge Changed', currentBadge, oldBadge);
			if(currentBadge === null && this.internalBadgeId !== null) {
				// The badge was deleted on another device
				await this.$bvModal.msgBoxOk( 'This badge was deleted on another device.', {
					title: 'Badge Deleted',
					centered: true,
					okTitle: 'Ok'
				});
				if(this.readOnlyBadge) {
					this.close();
				} else {
					this.internalBadgeId = null;
				}
			}
		}
	}

	@Watch('ticket')
	async onTicketChange(currentTicket: ITicket | null, oldTicket: ITicket | null) {
		if(this.dataLoaded) {
			if(oldTicket !== null && currentTicket !== null && oldTicket.modId === currentTicket.modId) {
				// There was no change
				return;
			}
			console.log('Ticket Changed', currentTicket, oldTicket);
			if(oldTicket === null && currentTicket !== null) {
				if(!this.readOnlyBadge) {
					if(this.oldInternalBadgeId !== this.internalBadgeId) {
						// Badge selector changed, ignore this
						return false;
					}
				}

				// This is the case when the ticket was created elsewhere
				await this.$bvModal.msgBoxOk( 'This badge was activated on another device.', {
					title: 'Badge Activated',
					centered: true,
					okTitle: 'Ok'
				});
				this.internalTicketId = currentTicket.ticketId;
			} else if(currentTicket === null) {
				// The ticket was closed somewhere else
				await this.$bvModal.msgBoxOk( 'This ticket was closed on another device.', {
					title: 'Ticket Closed',
					centered: true,
					okTitle: 'Ok'
				});
				if(this.readOnlyBadge) {
					await this.close();
				} else {
					// Don't close if it's the counter-pay, just reset
					this.internalTicketId = null;
				}

			} else {
				if(currentTicket.state === 'PAID') {
					await this.$bvModal.msgBoxOk( 'This ticket was paid and cannot be edited', {
						title: 'Ticket Paid',
						centered: true,
						okTitle: 'Ok'
					});
					await this.close('paid');
				} else {
					if(oldTicket !== null) {
						const isOrderingAvailable = this.location ? this.location.isOrderingAvailable : false;
						if(currentTicket.state === 'VIEWED' && (oldTicket.state === 'SENT' || oldTicket.state === 'OPEN')) {
							// If they just opened the ticket then don't fire
							return;
						} else if(
							currentTicket.badgeId === oldTicket.badgeId &&
							currentTicket.customer.phone === oldTicket.customer.phone &&
							currentTicket.customer.name === oldTicket.customer.name &&
							(isOrderingAvailable || currentTicket.total === oldTicket.total)
						) {
							// This can happen if they resend the sms so we need to check if anything actually changed
							return;
						}
					}

					// It was updated somewhere else
					await this.$bvModal.msgBoxOk( 'This ticket was updated on another device.', {
						title: 'Ticket Updated',
						centered: true,
						okTitle: 'Ok'
					});
					await this.internalTicketIdChange();
				}
			}
		}
	}

	get badges() {
		return BadgeStore.sortedByName.map((badge) => {
			const foundTicket = TicketStore.ticketByBadgeId(badge.badgeId);
			const localBadge: ILocalBadge = {
				name: badge.name,
				badgeId: badge.badgeId,
				ticketId: '',
				state: 'UNASSIGNED',
				ticket: null
			};
			if(foundTicket) {
				localBadge.ticketId = foundTicket.ticketId;
				localBadge.state = foundTicket.state;
				localBadge.ticket = foundTicket;
			}
			return localBadge;
		});
	}

	get badgeIdOptions() {
		return ([
			{
				value: null,
				text: '- No Table -'
			}
		] as {value: string | null, text: string}[]).concat(this.badges.map((badge) => {
			let state = '';
			if(badge.state !== 'UNASSIGNED') {
				state = ' (' + badge.state.substring(0, 1) + badge.state.toLowerCase().substring(1) + ')';
			}

			return {
				value: badge.badgeId,
				text: badge.name + state,
				disabled: badge.state === 'PAID'
			};
		}));
	}

	get selectedBadgeState() {
		const ticket = TicketStore.byId(this.internalTicketId as string);
		if(ticket !== null) {
			return ticket.state;
		}
		return 'UNASSIGNED';
	}

	get cleanedPhone() {
		return this.customerPhone;
	}

	mounted() {
		if(this.ticketId !== null) {
			this.internalTicketId = this.ticketId;
			if(!this.reusable) {
				this.readOnlyBadge = true;
			}
		} else if(this.badgeId !== null) {
			if(!this.reusable) {
				this.readOnlyBadge = true;
			}
			this.customerPhoneFocused = true;
			this.internalBadgeId = this.badgeId;
		} else {
			this.internalTicketId = null;
			this.internalBadgeId = null;
			this.customerPhoneFocused = true;
		}
		this.$nextTick(() => {
			this.dataLoaded = true;
		});
	}

	async createTicket() {
		if(!this.validate()) {
			return;
		}
		try {
			this.dataLoaded = false;
			this.showLoading = true;
			const ticketId = await WebService.createTicket({
				total: Number(this.billAmountInput.replace(/[^0-9]/g, '')),
				badgeId: this.internalBadgeId,
				customer: {
					id: this.customerId,
					name: this.customerName,
					phone: (this.customerPhone.startsWith('1') || this.customerPhone === '' ? '' : '1') + this.customerPhone
				},
				partySize: 1,
				waitTime: null,
				orderNotes: ''
			});
			this.showLoading = false;
			this.overlayColor = 'green';
			this.overlayMessage = `Ticket created`;
			this.showOverlay = true;
			setTimeout(() => {
				this.showOverlay = false;
				if(this.internalBadgeId === null) {
					this.showQR();
				}
				this.internalTicketId = ticketId;
				if(!this.reusable) {
					this.readOnlyBadge = true;
				}
				// this.$nextTick(() => {
				// 	this.dataLoaded = true;
				// });
				this.close();
			}, OverlayShowTime);
		} catch(e) {
			this.showLoading = false;
			await this.$bvModal.msgBoxOk( 'There was a problem creating your ticket', {
				title: 'Error',
				centered: true,
				okTitle: 'Ok'
			});
		}
	}

	async updateTicket() {
		if(!this.validate()) {
			return;
		}
		const ticket = TicketStore.byId(this.internalTicketId as string) as ITicket;
		try {
			this.dataLoaded = false;
			this.showLoading = true;
			await WebService.updateTicket(ticket.ticketId, {
				total: Number(this.billAmountInput.replace(/[^0-9]/g, '')),
				badgeId: this.internalBadgeId,
				customer: {
					id: this.customerId,
					name: this.customerName,
					phone: (this.customerPhone.startsWith('1') || this.customerPhone === '' ? '' : '1') + this.customerPhone
				},
				orderNotes: ticket.orderNotes,
				partySize: ticket.partySize,
				waitTime: ticket.waitTime
			});
			this.showLoading = false;
			this.overlayColor = 'blue';
			this.overlayMessage = `Ticket updated`;
			this.showOverlay = true;
			setTimeout(() => {
				this.showOverlay = false;
				// this.$nextTick(() => {
				// 	this.dataLoaded = true;
				// });
				this.close();
			}, OverlayShowTime);
		} catch(e) {
			this.showLoading = false;
			await this.$bvModal.msgBoxOk( 'There was a problem updating your ticket', {
				title: 'Error',
				centered: true,
				okTitle: 'Ok'
			});
		}
	}

	async resendSms() {
		if(!this.validate(true)) {
			return;
		}
		try {
			this.showLoading = true;
			await WebService.sendSms(this.internalTicketId as string, this.customerPhone);
			this.showLoading = false;
			this.overlayColor = 'blue';
			this.overlayMessage = `SMS Sent!`;
			this.showOverlay = true;
			setTimeout(() => {
				this.showOverlay = false;
			}, OverlayShowTime);
		} catch(e) {
			this.showLoading = false;
			await this.$bvModal.msgBoxOk( 'There was a problem sending the SMS', {
				title: 'Error',
				centered: true,
				okTitle: 'Ok'
			});
		}
	}

	validate(forcePhoneValidation = false) {
		const phoneCleaned = this.customerPhone;
		const billCleaned = Number(this.billAmountInput.replace(/[^0-9]/g, ''));
		if(phoneCleaned === '' && this.internalBadgeId === null && billCleaned === 0) {
			this.$bvModal.msgBoxOk('You must enter one of the following: Badge ID, Phone Number, or Bill Amount', {
				title: 'Error',
				centered: true,
				okTitle: 'Ok'
			});
			return false;
		}

		if((phoneCleaned.length > 0 || forcePhoneValidation) && phoneCleaned.length !== 10 && phoneCleaned.length !== 11) {
			this.$bvModal.msgBoxOk( 'You must enter a valid phone number', {
				title: 'Error',
				centered: true,
				okTitle: 'Ok'
			});
			return false;
		}
		return true;
	}

	async closeTicket() {
		try {
			if(this.ticket !== null) {
				let remainingBalance = '';
				if(this.ticket.amountDue !== 0) {
					remainingBalance = 'There is a balance due of ' + CurrencyFilter(this.ticket.amountDue) + '. ';
				}
				if(await this.$bvModal.msgBoxConfirm(remainingBalance + 'After a bill is closed, no additional ZeroContact payments can be made.', {
					centered: true,
					cancelTitle: 'Oops, keep open',
					okTitle: 'Close Bill'
				})) {
					try {
						this.dataLoaded = false;
						this.showLoading = true;
						await WebService.closeTicket((this.ticket as ITicket).ticketId);
						this.showLoading = false;
						this.overlayColor = 'blue';
						this.overlayMessage = `Ticket closed`;
						this.showOverlay = true;
						setTimeout(() => {
							this.showOverlay = false;
							this.internalBadgeId = null;
							this.internalTicketId = null;
							this.close();
						}, OverlayShowTime);
					} catch(e) {
						this.showLoading = false;
						await this.$bvModal.msgBoxOk( 'There was a problem closing your ticket', {
							title: 'Error',
							centered: true,
							okTitle: 'Ok'
						});
					}
				}
			}
		} catch(e) {
			console.error(e);
		}
	}

	showQR() {
		this.showQRCode = true;
	}

	closeQR() {
		this.showQRCode = false;
		// We just closed the badge for a reusable insert we need to clear it out
		if(this.reusable && this.internalBadgeId === null) {
			this.internalTicketId = null;
		}

	}


	@Watch('internalBadgeId')
	internalBadgeIdChange() {
		this.oldInternalBadgeId = this.internalBadgeId;
		this.dataLoaded = false;
		const badge = (find(this.badges, {badgeId: this.internalBadgeId}) as ILocalBadge);
		if(badge && badge.ticket) {
			this.internalTicketId = badge.ticketId;
		} else {
			this.internalTicketId = null;
		}
		this.$nextTick(() => {
			this.dataLoaded = true;
		});
	}

	@Watch('internalTicketId')
	internalTicketIdChange() {
		if(this.ticket !== null) {
			if(this.ticket.total !== null) {
				// Something with that .lazy modifier makes this get overridden if I don't
				// just delay till the next tick
				this.$nextTick(() => {
					this.billAmountInput = CurrencyFilter((this.ticket as ITicket).total);
				});
			} else {
				this.$nextTick(() => {
					this.billAmountInput = '';
				});
			}
			this.customerId = this.ticket.customer.id;
			this.customerName = this.ticket.customer.name ? this.ticket.customer.name : '';
			if(this.ticket.customer.phone !== null) {
				this.customerPhone = this.ticket.customer.phone;
			} else {
				this.customerPhone = '';
			}

			this.internalBadgeId = this.ticket.badgeId;
		} else {
			this.billAmountInput = '';
			this.customerName = '';
			this.customerPhone = '';
		}
	}

	close(reason: string = '') {
		this.$emit('close', reason);
	}

	// @Watch('cleanedPhone')
	// async phoneChange() {
	// 	console.log(await WebService.searchCustomers(this.cleanedPhone));
	// }

	@Watch('customerPhone')
	onCustomerPhoneChange() {
		// If the number changes then wipe the ID
		if(this.ticket && this.ticket.customer.phone !== this.customerPhone) {
			this.customerId = null;
		}
	}

	customerSelected(data: any) {
		console.log('Customer Selected', data);
		if(this.customerName.trim() === '') {
			this.customerName = data.name;
		}
		this.customerId = data.id;
	}

	async addItem() {
		if(this.ticket && this.ticket.isOrderingLocked) {
			await this.$bvModal.msgBoxOk('Ordering is locked, no more items can be added', {
				centered: true,
			});
		} else {
			this.showItemMenu = true;
		}
	}

	editItem(item: ICartMergedItem) {
		this.selectedItemId = item.itemId;
		this.selectedLineItemId = item.lineItemId as number;
		this.selectedMenuId = item.menuId;
		this.showItemOptions = true;
	}

	async removeItem(item: ICartMergedItem) {
		if(await this.$bvModal.msgBoxConfirm('Delete item?', {
			centered: true,
			okTitle: 'Delete'
		})) {
			try {
				this.dataLoaded = false;
				this.showLoading = true;
				await WebService.deleteLineItem(this.ticketId as string, item.lineItemId as number);
				this.showLoading = false;
				this.overlayColor = 'green';
				this.overlayMessage = `Item removed`;
				this.showOverlay = true;
				setTimeout(() => {
					this.showOverlay = false;
					this.dataLoaded = true;
				}, OverlayShowTime);
			} catch(e) {
				this.showLoading = false;
				await this.$bvModal.msgBoxOk( 'There was a problem removing your item', {
					title: 'Error',
					centered: true,
					okTitle: 'Ok'
				});
			}
		}
	}
}
